'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import TimezoneTypes from '../constants/TimezoneTypes';
import FormattedDateTime from './FormattedDateTime';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
export default class FormattedShortQuarterYear extends Component {
  render() {
    return /*#__PURE__*/_jsx(FormattedDateTime, Object.assign({
      format: "short-q-y"
    }, this.props));
  }
}
FormattedShortQuarterYear.displayName = 'FormattedShortQuarterYear';
FormattedShortQuarterYear.contextType = I18nHMRContext;
FormattedShortQuarterYear.propTypes = {
  type: PropTypes.oneOf([TimezoneTypes.PORTAL, TimezoneTypes.USER, TimezoneTypes.UTC]).isRequired,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.array]).isRequired
};